import { render, staticRenderFns } from "./UserCardMain.vue?vue&type=template&id=2d9b9e0e&"
import script from "./UserCardMain.vue?vue&type=script&lang=ts&"
export * from "./UserCardMain.vue?vue&type=script&lang=ts&"
import style0 from "./UserCardMain.vue?vue&type=style&index=0&id=2d9b9e0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports